import React from 'react';

import Grid from '@material-ui/core/Grid';

import H1 from 'apps/Pdf/components/common/H1';
import Spacer from 'apps/Pdf/components/common/Spacer';
import PageBreak from 'apps/Pdf/components/common/PageBreak';
import PlanBucket from 'apps/Pdf/components/Bucket/PlanBucket';
import BucketPieChart from 'apps/Pdf/components/Charts/BucketPieChart';
import HedgingRebalancing from 'apps/Pdf/components/HedgingRebalancing/HedgingRebalancing';
import CurrentPortfolioTable from 'apps/Pdf/components/Tables/CurrentPortfolioTable';
import CurrencyHedgingInstrumentsTable from '../components/CurrencyHedgingInstrumentsTable';
import SecuritiesTransactionsTable from '../components/SecuritiesTransactionsTable';
import ForexMovementsTable from '../components/ForexMovementsTable';
import InterestsTable from '../components/InterestsTable';

import useGeneralStyles from 'apps/Pdf/styles/general';
import { BucketDetailTablesData } from '../StatementInterface';
import { Bucket } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  title: string;
  term: 'longTerm' | 'midTerm' | 'shortTerm';
  currency: Currency;
  currentBalance: AmountValue;
  profit: AmountValue;
  profitPercent?: number;
  bucket: Bucket;
  detail: BucketDetailTablesData;
  savingIsins: string[];
}

const BucketDetail = (props: Props) => {
  const styles = useGeneralStyles();
  const { title, term, detail, bucket, profit, currentBalance, currency, profitPercent, savingIsins } = props;

  return (
    <>
      <PageBreak />

      <H1>
        {title}
        {!bucket.active && ' (neaktivní)'} - detail
      </H1>

      <div className={styles.twoColumns}>
        <PlanBucket
          term={term}
          data={bucket}
          currency={currency}
          profit={profit}
          profitPercent={profitPercent}
          currentBalance={currentBalance}
        />
        <Grid item container className={styles.center}>
          <BucketPieChart data={bucket.portfolio.chart.dataset} smaller />
          <HedgingRebalancing
            hedging={bucket.currencyHedging!}
            rebalancing={bucket.automaticRebalancing!}
            currency={currency}
            rebalancingTimeTest={bucket.rebalancingTimeTest}
          />
        </Grid>
      </div>

      <Spacer />

      <CurrentPortfolioTable
        total={bucket.portfolio.assetTotal}
        data={bucket.portfolio.assetCategories}
        currency={currency}
        savingIsins={savingIsins}
      />

      <CurrencyHedgingInstrumentsTable
        data={detail.currencyHedgingInstruments}
        total={detail.currencyHedgingTotal}
        currency={currency}
      />

      <InterestsTable data={detail.interests} total={detail.interestsTotal} currency={currency} />

      <SecuritiesTransactionsTable data={detail.securitiesTransactions} currency={currency} />

      <ForexMovementsTable data={detail.forexMovements} />
    </>
  );
};

export default BucketDetail;
